// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3n_nq","label":"LabeledBox_label__2C1PQ"};